import ActionTypes from './ActionTypes';
import Analytics from '@withlocals/withlocals-analytics';
import { fetchBooking as fetchBookingCall, confirmBooking as confirmBookingCall, cancelBooking as cancelBookingCall, withdrawOffer as withdrawOfferCall } from 'flux/clients/bookings';

export interface Actions {
  fetchBooking: (options: { id: string }) => void;
  confirmBooking: (options: { id: string }) => void;
  cancelBooking: (options: { id: string; isHosting: boolean; cancelExplanation?: string }) => any;
  rejectBooking: (options: { id: string }) => void;
  withdrawOffer: (options: { id: string }) => void;
}

export default function(dispatch: (action: ActionTypes) => void): Actions {
  return {
    fetchBooking({ id }) {
      dispatch({ type: 'BOOKING:FETCHING', payload: { id }});

      fetchBookingCall(id)
        .then(result => dispatch({ type: 'BOOKING:FETCHING_SUCCESS', payload: { id, result }}))
        .catch(error => dispatch({ type: 'BOOKING:FETCHING_ERROR', payload: { id, error }}));
    },
    confirmBooking({ id }) {
      Analytics.track('Booking environment', 'Confirm booking', id);
      confirmBookingCall({ id })
        .then(() => fetchBookingCall(id))
        .then(result => dispatch({ type: 'BOOKING:FETCHING_SUCCESS', payload: { id, result }}));
    },
    cancelBooking({ id, isHosting, cancelExplanation }) {
      Analytics.track('Booking environment', 'Cancel booking', isHosting ? 'Host' : 'Guest');
      return cancelBookingCall({ id, cancelExplanation })
        .then(result => {
          if (result.status === 'CONFIRMED') {
            dispatch({ type: 'BOOKING:TRANSFER', payload: { id, newHostId: result.host_id }})
          } else {
            fetchBookingCall(id)
              .then(result => dispatch({ type: 'BOOKING:FETCHING_SUCCESS', payload: { id, result }}));
          }
          return result;
        });
    },
    rejectBooking({ id }) {
      Analytics.track('Booking environment', 'Reject booking', id);
      cancelBookingCall({ id })
        .then(() => fetchBookingCall(id))
        .then(result => dispatch({ type: 'BOOKING:FETCHING_SUCCESS', payload: { id, result }}));
    },
    withdrawOffer({ id }) {
      Analytics.track('Booking environment', 'Withdraw personalised offer', id);
      withdrawOfferCall({ id })
        .then(() => fetchBookingCall(id))
        .then(result => {
          dispatch({ type: 'BOOKING:FETCHING_SUCCESS', payload: { id, result }});
        });
    }
  };
}
